import queries from '@apis/queries';
import Column from '@components/Column';
import Image from '@components/Image';
import ImageIndicator from '@components/ImageIndicator';
import Row from '@components/Row';
import Text from '@components/Text';
import { ItemResponse } from '@models/item';
import { useQuery } from '@tanstack/react-query';
import { useRef, useState } from 'react';
import Slider from 'react-slick';

import useNutritionModal from './hooks/useNutritionModal';
import InfoIcon from './InfoIcon';
import ItemImages from './ItemImages';
import SearchIcon from './SearchIcon';
import styles from './styles.module.scss';

interface Props {
    item: ItemResponse;
    shopId: string;
}

function ItemInfo({ item }:Props) {
  const { name, description, imageUrls } = item;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { openNutritionModal, nutritionExists } = useNutritionModal(item.id);
  const [index, setIndex] = useState<number>(0);
  const sliderRef = useRef<Slider>(null);
  return (
        <Column as='section' align='center' className={styles.container}
                fullWidth
                spacing={12}>
            <div className={styles.thumbnail}>
                {imageUrls.length > 1 ? (
                    <Slider dots={false}
                            ref={sliderRef}
                            className={styles.slider}
                            afterChange={(newIndex) => {
                              setIndex(newIndex);
                            }}>
                        {imageUrls.map((imageUrl) => (
                            <Image src={imageUrl}
                                   className={styles.img}
                                   key={imageUrl}
                                   alt={name}
                                   width={110}
                                   height={110}/>
                        ))}
                    </Slider>
                ) : (
                    <Image src={imageUrls[0]}
                           className={styles.img}
                           alt={name}
                           width={110}
                           height={110}/>
                )}
                <ImageIndicator current={index}
                                size={imageUrls.length}
                                slickPrev={() => sliderRef.current?.slickPrev()}
                                slickNext={() => sliderRef.current?.slickNext()} />
                <Row className={styles.info} spacing={4}>
                    {nutritionExists && (
                        <InfoIcon onClick={openNutritionModal} />
                    )}

                    <SearchIcon onClick={() => setIsOpen(true)}/>
                </Row>
            </div>
            <Text size='3xl'
                  fontWeight='bold'
                  className={styles.name}
                  align='center' >
                {name}
            </Text>
            <Text align='center' className={styles.name}>
                {description}
            </Text>
            <ItemImages images={imageUrls}
                        setIsOpen={setIsOpen}
                        isOpen={isOpen} />
        </Column>
  );
}

export default ItemInfo;
